// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeEnrollmentApi = class EdgeEnrollmentApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param BasicEnrollmentRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async clientEnrollmentCreateEnrollment(BasicEnrollmentRequest, x_program_id) {
        const _url_ = '/edge/enrollment/v1/basic/enrollment/createEnrollment';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'BasicEnrollmentRequest' is not null or undefined
        if (BasicEnrollmentRequest === null || BasicEnrollmentRequest === undefined) {
            throw new Error('Required parameter BasicEnrollmentRequest was null or undefined when calling clientEnrollmentCreateEnrollment.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(BasicEnrollmentRequest, "BasicEnrollmentRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "BasicEnrollmentResponse");
        }
        return response;
    }
    /**
     *
     * @param BasicEnrollmentDeactivateRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async clientEnrollmentDeactivateEnrollment(BasicEnrollmentDeactivateRequest, x_program_id) {
        const _url_ = '/edge/enrollment/v1/basic/enrollment/deactivateEnrollment';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'BasicEnrollmentDeactivateRequest' is not null or undefined
        if (BasicEnrollmentDeactivateRequest === null || BasicEnrollmentDeactivateRequest === undefined) {
            throw new Error('Required parameter BasicEnrollmentDeactivateRequest was null or undefined when calling clientEnrollmentDeactivateEnrollment.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(BasicEnrollmentDeactivateRequest, "BasicEnrollmentDeactivateRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "BasicEnrollmentDeactivateResponse");
        }
        return response;
    }
    /**
     *
     * @param accountId
     * @param x_program_id The program id from the list of allowed program ids
     */
    async clientEnrollmentGetEnrollmentByAccountId(accountId, x_program_id) {
        const _url_ = '/edge/enrollment/v1/basic/enrollment/getEnrollmentByAccountId/{accountId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling clientEnrollmentGetEnrollmentByAccountId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "BasicEnrollmentResponse");
        }
        return response;
    }
    /**
     *
     * @param GetEnrollmentByExternalIdRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async clientEnrollmentGetEnrollmentByExternalId(GetEnrollmentByExternalIdRequestModel, x_program_id) {
        const _url_ = '/edge/enrollment/v1/basic/enrollment/getEnrollmentByExternalId';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'GetEnrollmentByExternalIdRequestModel' is not null or undefined
        if (GetEnrollmentByExternalIdRequestModel === null || GetEnrollmentByExternalIdRequestModel === undefined) {
            throw new Error('Required parameter GetEnrollmentByExternalIdRequestModel was null or undefined when calling clientEnrollmentGetEnrollmentByExternalId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(GetEnrollmentByExternalIdRequestModel, "GetEnrollmentByExternalIdRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClientEnrollmentControllerGetEnrollmentByExternalIdResponse");
        }
        return response;
    }
    /**
     *
     * @param memberNumber
     * @param x_program_id The program id from the list of allowed program ids
     */
    async clientEnrollmentGetEnrollmentByMemberNumber(memberNumber, x_program_id) {
        const _url_ = '/edge/enrollment/v1/basic/enrollment/getEnrollmentByMemberNumber/{memberNumber}'
            .replace('{' + 'memberNumber' + '}', encodeURIComponent(String(memberNumber)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'memberNumber' is not null or undefined
        if (memberNumber === null || memberNumber === undefined) {
            throw new Error('Required parameter memberNumber was null or undefined when calling clientEnrollmentGetEnrollmentByMemberNumber.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "BasicEnrollmentResponse");
        }
        return response;
    }
    /**
     *
     * @param GetEnrollmentStatusRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async clientEnrollmentGetEnrollmentStatus(GetEnrollmentStatusRequestModel, x_program_id) {
        const _url_ = '/edge/enrollment/v1/basic/enrollment/getEnrollmentStatus';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'GetEnrollmentStatusRequestModel' is not null or undefined
        if (GetEnrollmentStatusRequestModel === null || GetEnrollmentStatusRequestModel === undefined) {
            throw new Error('Required parameter GetEnrollmentStatusRequestModel was null or undefined when calling clientEnrollmentGetEnrollmentStatus.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(GetEnrollmentStatusRequestModel, "GetEnrollmentStatusRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentStatusResponseModel");
        }
        return response;
    }
    /**
     *
     * @param accountId
     * @param BasicEnrollmentRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async clientEnrollmentUpdateEnrollment(accountId, BasicEnrollmentRequest, x_program_id) {
        const _url_ = '/edge/enrollment/v1/basic/enrollment/updateEnrollment/{accountId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling clientEnrollmentUpdateEnrollment.');
        }
        // verify required parameter 'BasicEnrollmentRequest' is not null or undefined
        if (BasicEnrollmentRequest === null || BasicEnrollmentRequest === undefined) {
            throw new Error('Required parameter BasicEnrollmentRequest was null or undefined when calling clientEnrollmentUpdateEnrollment.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(BasicEnrollmentRequest, "BasicEnrollmentRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "BasicEnrollmentResponse");
        }
        return response;
    }
    /**
     *
     * @param EnrollmentIsValidMemberNumberRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async enrollmentCheckMemberNumber(EnrollmentIsValidMemberNumberRequestModel, x_program_id) {
        const _url_ = '/edge/enrollment/CheckMemberNumber';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'EnrollmentIsValidMemberNumberRequestModel' is not null or undefined
        if (EnrollmentIsValidMemberNumberRequestModel === null || EnrollmentIsValidMemberNumberRequestModel === undefined) {
            throw new Error('Required parameter EnrollmentIsValidMemberNumberRequestModel was null or undefined when calling enrollmentCheckMemberNumber.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(EnrollmentIsValidMemberNumberRequestModel, "EnrollmentIsValidMemberNumberRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentCheckMemberNumberDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param EnrollPatientRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async enrollmentEnrollPatient(EnrollPatientRequestModel, x_program_id) {
        const _url_ = '/edge/enrollment/EnrollPatient';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'EnrollPatientRequestModel' is not null or undefined
        if (EnrollPatientRequestModel === null || EnrollPatientRequestModel === undefined) {
            throw new Error('Required parameter EnrollPatientRequestModel was null or undefined when calling enrollmentEnrollPatient.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(EnrollPatientRequestModel, "EnrollPatientRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentEnrollPatientDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param GetBestEnrollmentRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async enrollmentGetBestEnrollment(GetBestEnrollmentRequest, x_program_id) {
        const _url_ = '/edge/enrollment/getBestEnrollment';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'GetBestEnrollmentRequest' is not null or undefined
        if (GetBestEnrollmentRequest === null || GetBestEnrollmentRequest === undefined) {
            throw new Error('Required parameter GetBestEnrollmentRequest was null or undefined when calling enrollmentGetBestEnrollment.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(GetBestEnrollmentRequest, "GetBestEnrollmentRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "GetBestEnrollmentResponse");
        }
        return response;
    }
    /**
     *
     * @param GetBestEnrollmentRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async enrollmentGetBestEnrollment_1(GetBestEnrollmentRequest, x_program_id) {
        const _url_ = '/edge/enrollment/GetBestEnrollment';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'GetBestEnrollmentRequest' is not null or undefined
        if (GetBestEnrollmentRequest === null || GetBestEnrollmentRequest === undefined) {
            throw new Error('Required parameter GetBestEnrollmentRequest was null or undefined when calling enrollmentGetBestEnrollment_1.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(GetBestEnrollmentRequest, "GetBestEnrollmentRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentGetBestEnrollmentDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param GetBestEnrollmentV2RequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async enrollmentGetBestEnrollmentsV2(GetBestEnrollmentV2RequestModel, x_program_id) {
        const _url_ = '/edge/enrollment/GetBestEnrollmentsV2';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'GetBestEnrollmentV2RequestModel' is not null or undefined
        if (GetBestEnrollmentV2RequestModel === null || GetBestEnrollmentV2RequestModel === undefined) {
            throw new Error('Required parameter GetBestEnrollmentV2RequestModel was null or undefined when calling enrollmentGetBestEnrollmentsV2.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(GetBestEnrollmentV2RequestModel, "GetBestEnrollmentV2RequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentGetBestEnrollmentsV2DefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param EnrollmentWithEmailSignaturePdfRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async patientEnrollmentEnrollmentWithEmailSignaturePdfRequest(EnrollmentWithEmailSignaturePdfRequest, x_program_id) {
        const _url_ = '/edge/enrollment/v2/patient/enrollmentWithEmailSignaturePdfRequest';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'EnrollmentWithEmailSignaturePdfRequest' is not null or undefined
        if (EnrollmentWithEmailSignaturePdfRequest === null || EnrollmentWithEmailSignaturePdfRequest === undefined) {
            throw new Error('Required parameter EnrollmentWithEmailSignaturePdfRequest was null or undefined when calling patientEnrollmentEnrollmentWithEmailSignaturePdfRequest.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(EnrollmentWithEmailSignaturePdfRequest, "EnrollmentWithEmailSignaturePdfRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientEnrollmentControllerEnrollmentWithEmailSignaturePdfRequestResponse");
        }
        return response;
    }
    /**
     *
     * @param EnrollmentWithEmailSignatureTemplateRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async patientEnrollmentEnrollmentWithEmailSignatureTemplateRequest(EnrollmentWithEmailSignatureTemplateRequest, x_program_id) {
        const _url_ = '/edge/enrollment/v2/patient/enrollmentWithEmailSignatureTemplateRequest';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'EnrollmentWithEmailSignatureTemplateRequest' is not null or undefined
        if (EnrollmentWithEmailSignatureTemplateRequest === null || EnrollmentWithEmailSignatureTemplateRequest === undefined) {
            throw new Error('Required parameter EnrollmentWithEmailSignatureTemplateRequest was null or undefined when calling patientEnrollmentEnrollmentWithEmailSignatureTemplateRequest.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(EnrollmentWithEmailSignatureTemplateRequest, "EnrollmentWithEmailSignatureTemplateRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientEnrollmentControllerEnrollmentWithEmailSignatureTemplateRequestResponse");
        }
        return response;
    }
    /**
     *
     * @param EnrollmentWithSignatureUpload default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async patientEnrollmentEnrollmentWithSignatureDocumentUpload(EnrollmentWithSignatureUpload, x_program_id) {
        const _url_ = '/edge/enrollment/v2/patient/enrollmentWithSignatureDocumentUpload';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'EnrollmentWithSignatureUpload' is not null or undefined
        if (EnrollmentWithSignatureUpload === null || EnrollmentWithSignatureUpload === undefined) {
            throw new Error('Required parameter EnrollmentWithSignatureUpload was null or undefined when calling patientEnrollmentEnrollmentWithSignatureDocumentUpload.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(EnrollmentWithSignatureUpload, "EnrollmentWithSignatureUpload"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientEnrollmentControllerEnrollmentWithSignatureDocumentUploadResponse");
        }
        return response;
    }
    /**
     *
     * @param x_program_id The program id from the list of allowed program ids
     */
    async paymentPaymentMethod(x_program_id) {
        const _url_ = '/edge/enrollment/Payment/PaymentMethod';
        let _params_ = {};
        let _headers_ = {};
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentPaymentPaymentMethodPaymentMethodResponse");
        }
        return response;
    }
};
EdgeEnrollmentApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeEnrollmentApi);
export { EdgeEnrollmentApi };
//# sourceMappingURL=edgeEnrollmentApi.js.map